<template>
  <div class="edit-platform">
    <!--标题-->
    <!-- <div class="breadcrumb" style="background: #fff">申请线下充值</div> -->
    <div class="breadcrumb" style="background: #fff">积分变动</div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" hide-required-asterisk label-width="100px" class="demo-ruleForm">
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="平台积分:" prop="">
          <el-input v-model="storePoint" disabled></el-input>
        </el-form-item>
        <el-form-item label="收支类型:" prop="">
          <el-radio-group v-model="ruleForm.changeType">
            <el-radio label="RECHARGE">充值</el-radio>
            <el-radio label="USE">抵扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="变动数量:" prop="changeNumber">
          <el-input v-model="ruleForm.changeNumber" type="number" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="ruleForm.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button" style="justify-content: flex-end;padding-left:120px;">
        <el-button type="primary" round @click="submitForm('ruleForm')" :loading="loading">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { storeQueryListByCode, storeQueryByStoreCode, changePoint, getUserPoints } from '@/api/crm'
export default {
  name: 'changePoint',
  data () {
    return {
      show: false,
      code: '',
      storePoint: 0,
      ruleForm: {
        attachType: 'WD',
        flowType: 0,
        storeName: '',
        storeId: '',
        changeType: 'RECHARGE',
        changeNumber: 0,
        remark: ''
      },
      rules: {
        changeNumber: [
          { required: true, message: '请输入变动数量', trigger: 'blur' }
        ]
      },
      loading: false

    }
  },
  methods: {
    handleSelect (item) {
      this.ruleForm.storeId = item.id
      // 获取平台积分
      getUserPoints(item.id, 'WD').then(res => {
        if (res.data.success) {
          if (res.data.data.storeId == this.ruleForm.storeId) {
            this.storePoint = res.data.data.pointsStoreItem.currentlyPoints
          }
        }
      })
    },
    querySearchAsync (queryString, cb) {
      console.log('querySearchAsync', queryString.length)
      let data = queryString.trim()
      if (data !== '') {
        storeQueryListByCode(data).then(res => {
          res.data.data.forEach(item => {
            item.value = item.code
          })
          cb(res.data.data)
        })
      }
    },
    // 验证平台
    verifyStore () {
      this.code = this.code.replace(/\s*/g, '')
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.ruleForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },

    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        console.log(this.ruleForm, 'formName')
        if (valid) {
          this.loading = true
          changePoint(this.ruleForm).then(res => {
            if (res.data.success) {
              this.$message({
                message: '申请成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped></style>
